import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import NotificationPanel from './NotificationPanel';
import { useNotifications } from '../../hooks/useNotifications';

const { FiBell } = FiIcons;

const NotificationBell = ({ userId }) => {
  const [open, setOpen] = useState(false);
  const {
    notifications, unreadCount, urgentUnread, loading,
    markRead, markAllRead, deleteNotification,
  } = useNotifications(userId);

  if (!userId) return null;

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(o => !o)}
        className={`relative w-10 h-10 flex items-center justify-center rounded-2xl transition-all ${
          open
            ? 'bg-brand-pink/15 border border-brand-pink/30 text-brand-pink'
            : 'glass-card text-zinc-400 hover:text-white hover:border-brand-pink/20'
        }`}
      >
        <SafeIcon icon={FiBell} className="text-lg" />

        {/* Urgent ring */}
        {urgentUnread > 0 && (
          <span className="absolute inset-0 rounded-2xl border-2 border-red-500 animate-ping opacity-40" />
        )}

        {/* Badge */}
        {unreadCount > 0 && (
          <span className={`absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 text-white text-[9px] font-black rounded-full flex items-center justify-center shadow-lg ${
            urgentUnread > 0
              ? 'bg-red-500 shadow-red-500/40 animate-bounce'
              : 'bg-gradient-to-r from-brand-pink to-brand-coral shadow-brand-pink/30'
          }`}>
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {open && (
        <NotificationPanel
          notifications={notifications}
          unreadCount={unreadCount}
          loading={loading}
          onMarkRead={markRead}
          onMarkAllRead={markAllRead}
          onDelete={deleteNotification}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
};

export default NotificationBell;